import React, { CSSProperties, FC, useEffect, useState } from 'react';
import classnames from 'classnames';
import { Spin } from 'antd';
import styles from './index.module.less';

const iconList = Array.from({ length: 6 }, (_, index) => index + 1);

const Loading: FC<{ progress: number; className?: string; style?: CSSProperties }> = (props) => {
  const { className = '', progress, style } = props;
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    const activeCount = Math.floor(iconList.length * (progress / 100));
    setActiveCount(activeCount);
  }, [progress]);

  return (
    <div className={classnames(styles.loadingContainer, className)} style={style}>
      {/* <div className={styles.loadingSprite} /> */}
      <div className={styles.loadingList}>
        {iconList.map((el) => {
          return <span className={classnames(styles.loading, { [styles.active]: el <= activeCount })} key={el} />;
        })}
      </div>
      <div className={styles.loadingPercent}>{progress?.toFixed(2)}%</div>
    </div>
  );
};

export default Loading;
